import Vue from "vue";
import VueI18n from "vue-i18n";
import en_US from "./en_US";
import zh_CN from "./zh_CN";
import zh_HK from "./zh_HK";
Vue.use(VueI18n);

var locale = localStorage.getItem("language")
if (!locale) {
  locale = "zh_CN"
  localStorage.setItem("language", locale)
}

const i18n = new VueI18n({
  locale,
  legacy: false,
  messages: {
    zh_CN: zh_CN,
    zh_HK: zh_HK,
    en_US: en_US
  },
  fallbackLocale: "zh_CN"
});

export const $t = (text) => i18n.tc(text);

export default i18n;



// WEBPACK FOOTER //
// ./src/lang/index.js